import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import {
    PanelWrapper,
    LeftContainer,
    RightContainer,
    TopContainer,
    BottomContainer
} from './Panel.style';

import Button from '@mlb/react-patterns/v4/components/Button/button';
import { ButtonShapes } from '@mlb/react-patterns/v4/components/Button/button.types';

import SIDES from './utils/sides';

import useTracking from '@gameday/utils/hooks/useTracking';

const sideContainers = {
    left: LeftContainer,
    right: RightContainer,
    top: TopContainer,
    bottom: BottomContainer
};

const Panel = ({
    children,
    controlOpen = false,
    side = SIDES.LEFT,
    hideButton = false,
    toggleHandler,
    trackingId = 'panel'
}) => {
    const tracking = useTracking();
    const [open, setOpen] = useState(false);

    const togglePanel = useCallback((openState, clicked = false) => {
        setOpen(openState);

        // Needed so that it doesn't call on initialization
        if (clicked) {
            const trackingText = `toggled ${openState ? 'open' : 'closed'}`;
            const cfg = {
                componentName: ['Panel', trackingId],
                text: trackingText,
                activity: trackingText
            };
            tracking?.track.track_click(cfg);
        }

        if (toggleHandler) {
            toggleHandler(openState);
        }
    }, [setOpen, toggleHandler]);

    useEffect(() => {
        togglePanel(controlOpen);
    }, [controlOpen, togglePanel, toggleHandler]);

    const Container = sideContainers[side] || LeftContainer;

    return (
        <Container open={ open }>
            {!hideButton
                ? <Button
                    shape={ButtonShapes.HOLLOW_BORDERLESS}
                    iconName='carousel-arrow-left'
                    handlers={{ onClick: () => { togglePanel(!open, true); } }}
                    hasHover={false}
                    role='switch'
                    ariaLabel={`Toggle ${side} panel.`}
                    className={'panel-btn'}
                />
                : null }
            <PanelWrapper>
                {children}
            </PanelWrapper>
        </Container>
    );
};

Panel.propTypes = {
    controlOpen: PropTypes.bool,
    side: PropTypes.string,
    hideButton: PropTypes.bool,
    toggleHandler: PropTypes.func,
    trackingId: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default withTheme(Panel);
